import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getStoredConsent, saveConsent } from '../utils/googleAds';

const ConsentContext = createContext(null);
export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(() => getStoredConsent());
  const [preferencesOpen, setPreferencesOpen] = useState(() => !getStoredConsent());
  const choose = useCallback((advertising) => { setConsent(saveConsent(advertising)); setPreferencesOpen(false); }, []);
  const value = useMemo(() => ({ consent, preferencesOpen, choose, openPreferences: () => setPreferencesOpen(true), closePreferences: () => setPreferencesOpen(false) }), [consent, preferencesOpen, choose]);
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}
export function useConsent() { const value = useContext(ConsentContext); if (!value) throw new Error('useConsent must be used within ConsentProvider'); return value; }
